module.exports = __webpack_public_path__ + "img/fruit_cantaloupe.ee1ca860.png";